<!-- 照明 -->
<style lang="scss" scoped></style>

<template>
  <custom-return></custom-return>
</template>
<script>
import bus from "@/components/three-scene/Bus.js";
import { getIllumination } from "@/api/index.js";
export default {
  data() {
    return {
      timer: null,
    };
  },
  mounted() {
    this.$store.state.threeEvent.intoIllumina = true;
  },
  created() {
    this.getIll();
    this.timer = setInterval(() => {
      this.getIll();
    }, 30 * 60 * 1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    async getIll() {
      let { data: res } = await getIllumination();
      if (res == 1) {
        bus.emit("light", true);
      } else {
        bus.emit("light", false);
      }
    },
  },
};
</script>
